<template>
    <div>
        <div class="top">
            <van-nav-bar title="院系和专业" left-text="返回" left-arrow @click-left="onClickLeft" />
        </div>
        <div class="menu">
            <div
                :class="currentId === index?'menu-item-on':'menu-item-off'"
                v-for="(item,index) in tabs"
                :key="index"
                @click="selectMenu(item,index)"
            >{{item}}</div>
        </div>
        <van-list  class="content" v-if="currentId === 0" finished-text="没有更多了"
             @load="onLoad"
             :finished="finished">
            <div class="college-item" v-for="(item,index) in college" :key="index" @click="collegeDetail(item.id)">
                <div class="background"></div>
                <div class="title">{{item.title}}</div>
                <div class="icon">
                    <van-icon name="arrow" />
                </div>
            </div>
        </van-list >
        <van-list  class="content" v-if="currentId === 1" finished-text="没有更多了"
             @load="onLoad"
             :finished="finished">
            <div class="major-item" v-for="(item,index) in major" :key="index" >
                <div class="major-title">{{item.depart}}</div>
                <div class="major" v-for="(item,index) in item.data" :key="index" @click="majorDetail(item.mid)">
                    {{item.title}}
                    <div class="icon">
                        <van-icon name="arrow" />
                    </div>
                </div>
            </div>
        </van-list >
    </div>
</template>

<script>
import { httpPost, httpGet } from "../../../../axios/index";

export default {
    name: "college",
    data() {
        return {
            currentId: 0,
            tabs: [],
            college: [],
            major: [],
            finished: false,
            page:1
        };
    },
    methods: {
        // 上拉加载
        onLoad(){
             this.page = this.page + 1;
            if(this.currentTab==1){
                 httpPost("/saas/major", {
                    schoolid: this.$route.query.id,
                    page: this.page
            }).then(res => {
              
                if (res.code === 1) {
                   this.major = [...this.major, ...res.data];
                } else {
                    this.finished = true;
                }
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true
                });
            });
            }
        },
        // 点击进入详情
        collegeDetail(e){
            this.$router.push({
                path:"/yuanzhuan/collegeDetail",
                query:{
                    schoolid: this.$route.query.id,
                    id:e
                } 
            })
        },
        majorDetail(e){
          
            this.$router.push({
                path:"/yuanzhuan/majorDetail",
                query:{
                     schoolid: this.$route.query.id,
                    id:e
                } 
            })
        },
        onClickLeft() {
            this.$router.go(-1);
        },
        selectMenu(item, index) {
            this.currentId = index;
        },
        loadInfo() {
            httpPost("/saas/lists", {
                schoolid: this.$route.query.id,
                mark: 4
            }).then(response => {
                if (response.code === 1) {
                    this.tabs = response.tags;
                    this.college = response.college;
                    this.major = response.major;
                }
            });
        }
    },
    mounted() {
        this.loadInfo();
    }
};
</script>

<style scoped>
.menu {
    display: flex;
    font-size: 1.2rem;
}
.menu-item-on,
.menu-item-off {
    width: 50vw;
    text-align: center;
    padding: 0.5rem 0;
}
.menu-item-on {
    color: #25bafd;
}
.content {
    background: #f2f2f2;
    padding-top: 0.5rem;
}
.background {
    width: 0.5rem;
    height: 5rem;
    background: #25bafd;
}
.college-item {
    margin-top: 0.5rem;
    background: #fff;
    font-size: 1.1rem;
    line-height: 5rem;
    display: flex;
    position: relative;
    font-weight: 600;
}
.title {
    padding-left: 1rem;
}
.icon {
    position: absolute;
    right: 0.5rem;
    top: 0;
    bottom: 0;
    margin: auto 0;
    font-size: 1.2rem;
}
.major-item {
    margin-top: 0.5rem;
    background: #fff;
    font-size: 1.1rem;
    line-height: 3rem;
}
.major-title {
    padding-left: 1rem;
    border-bottom: 0.02rem #f2f2f2 solid;
}
.major {
    font-size: 1rem;
    padding-left: 4rem;
    border-bottom: 0.02rem #f2f2f2 solid;
    position: relative;
}
</style>